import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
  NgbModal,
  NgbTooltipModule,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { OrderManagementService } from '../../../Services/order-management.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { stat } from 'node:fs';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { release } from 'node:os';
import { apiEndPoints } from '../../../api/apiEndPoint';

@Component({
  selector: 'app-process-payment',
  standalone: true,
  imports: [
    NgIf,
    NgbTooltipModule,
    NgFor,
    CommonModule,
    NgbPaginationModule,
    ReactiveFormsModule,
    ToastrModule,
  ],
  templateUrl: './process-payment.component.html',
  styleUrls: ['./process-payment.component.css'],
})
export class ProcessPaymentComponent implements OnInit {
  @ViewChild('confirmationModal') confirmationModal!: TemplateRef<any>;
  @ViewChild('bankDetailsModal') bankDetailsModal!: TemplateRef<any>;

  isPaid: boolean = false;
  selectedRow: any;
  originalTableData: any[] = [];
  selectedBankDetails: any;
  // Pagination Variables
  currentPage: number = 1;
  pageSize: number = 5; // Number of items per page
  pagedTableData: any[] = [];
  listForm: FormGroup;
  bankForm: FormGroup;
  releasePaymentList: any;
  bankData: any;
  selectedOrderId: any;
  selectedIdForBank: any;
  selectedRowOrderId: any;
  selectedRequestorId: any;
  selectedStatusCode: any;
  selectedDumpsterAmnt: any;
  selectedDumpyardAmnt: any;
  selectedSmartSortAmnt: any;
  selectedRefundReqAmnt: any;

  uniqueDumpStatus: string[] = ['Waste disposed', 'Yet to Dispose'];
  uniqueContainerType: string[] = [];
  uniqueOrderStatus: string[] = ['Order Closed', 'Order Inprocess'];

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private orderService: OrderManagementService,
    private toastr: ToastrService
  ) {
    this.listForm = this.fb.group({
      userType: [{ value: '', disabled: true }],
      companyName: [{ value: '', disabled: true }],
      mobileNumber: [{ value: '', disabled: true }],
      city: [{ value: '', disabled: true }],
      zone: [{ value: '', disabled: true }],
      requestDate: [{ value: '', disabled: true }],
      scheduleDate: [{ value: '', disabled: true }],
      containerType: [{ value: '', disabled: true }],
      containerCapacity: [{ value: '', disabled: true }],
      noOfContainer: [{ value: '', disabled: true }],
      rentalDuration: [{ value: '', disabled: true }],
      sarFromRequestor: [{ value: '', disabled: true }],
      dumpsterName: [{ value: '', disabled: true }],
      dumpsterMblNo: [{ value: '', disabled: true }],
      dumpyardName: [{ value: '', disabled: true }],
      dumpyardMblNo: [{ value: '', disabled: true }],
    });

    this.bankForm = this.fb.group({
      requestorBank: [{ value: '', disabled: true }],
      requestorIban: [{ value: '', disabled: true }],
      dumpsterBank: [{ value: '', disabled: true }],
      dumpsterIban: [{ value: '', disabled: true }],
      dumpyardBank: [{ value: '', disabled: true }],
      dumpyardIban: [{ value: '', disabled: true }],
    });
  }

  ngOnInit() {
    this.getReleasePayment();
  }

  openDetailModal(modal: any, row: any) {
    this.selectedOrderId = row.orderId;

    const formatDate = (date: string | null): string => {
      if (!date) return '';
      const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true, 
      };
      return new Intl.DateTimeFormat('en-GB', options).format(new Date(date));
    };

    const formattedReqDate = formatDate(row.requestDate);
    const formattedScheduledDate = formatDate(row.scheduledDate);
    this.listForm.patchValue({
      userType: row.requestorType,
      companyName: row.requestorName,
      mobileNumber: row.requestorMobileNo,
      city: row.cityName,
      zone: row.zoneName,
      requestDate: formattedReqDate,
      scheduleDate: formattedScheduledDate,
      containerType: row.containerType,
      containerCapacity: row.containerCapacity,
      noOfContainer: row.noOfContainer,
      rentalDuration: row.containerRent,
      sarFromRequestor: row.sarFromRequestor,
      dumpsterName: row.dumpsterCompanyName,
      dumpsterMblNo: row.dumpsterMobileNo,
      dumpyardName: row.dumpyardCompanyName,
      dumpyardMblNo: row.dumpyardMobileNo,
    });
    this.modalService.open(modal, { ariaLabelledBy: 'details-modal-title' });
  }

  onSearch(event: any): void {
    const searchText = event.target.value.toLowerCase();

    if (searchText) {
      this.releasePaymentList = this.originalTableData.filter(
        (item: any) =>
          item.requestorId.toLowerCase().includes(searchText) ||
          item.requestorName.toLowerCase().includes(searchText)
      );
    } else {
      this.releasePaymentList = [...this.originalTableData];
    }
  }

  // -------------------------------- Get Release Payment List API -------------------------------- //

  getReleasePayment() {
    this.orderService.getReleasePayment(apiEndPoints.releasePayment).subscribe({
      next: (response: any) => {
        if (response.body.details) {

          this.releasePaymentList = response.body.details.filter((data: any) =>
            (data.orderStatus >= 110 && data.orderStatus != 114) &&
            !(
              (data.dumpesterOrderStatus === "135" && data.dumpyarOrderStatus === "142" && data.orderStatus === "113") ||
              (data.dumpesterOrderStatus === "135" && data.dumpyarOrderStatus === "142" && data.sarRefundtoRequester === "0")
            )
          );

          console.log(this.releasePaymentList)
          this.releasePaymentList.forEach((payment: any) => {
            payment.dumpStatusText =
              payment.dumpyarOrderStatus >= '141'
                ? 'Waste disposed'
                : 'Yet to Dispose';

            if (!this.uniqueContainerType.includes(payment.containerType)) {
              this.uniqueContainerType.push(payment.containerType);
            }
          });

          this.originalTableData = [...this.releasePaymentList];
        } else {
          this.releasePaymentList = [];
          this.originalTableData = [];
        }

        console.log(this.releasePaymentList);

        // this.releasePaymentList.forEach((payment: any) => {
        //   if (payment.orderStatus == '110') {
        //     payment.requestorTripConfirmationText = 'All trips confirmed';
        //   } else {
        //     payment.requestorTripConfirmationText = 'Not yet confirmed';
        //   }

        //   if (payment.dumpyarOrderStatus == '140') {
        //     payment.dumpyardTripConfirmationText = 'All trips confirmed';
        //   } else {
        //     payment.dumpyardTripConfirmationText = 'Not yet confirmed';
        //   }
        // });
      },
    });
  }

  // -------------------------------- Pagination -------------------------------- //

  get pagedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.releasePaymentList?.slice(start, end);
  }

  // Handle page change event
  onPageChange(page: number) {
    this.currentPage = page;
  }

  // -------------------------------- Get Bank Details API -------------------------------- //

  openBankDetailsModal(modal: any, row: any) {
    this.selectedIdForBank = row.orderId;
    this.modalService.open(modal, {
      ariaLabelledBy: 'bank-details-modal-title',
    });
    let selectedOrderId = row.orderId;

    this.orderService
      .getBankDetails(apiEndPoints.getBankDetails, selectedOrderId)
      .subscribe({
        next: (response: any) => {
          this.bankData = response.body.details;
          this.bankForm.patchValue({
            requestorBank: this.bankData.requestorBankName,
            requestorIban: this.bankData.requestorIbanNo,
            dumpsterBank: this.bankData.dumpsterBankName,
            dumpsterIban: this.bankData.dumpsterIbanNo,
            dumpyardBank: this.bankData.dumpyardBankName,
            dumpyardIban: this.bankData.dumpyardIbanNo,
          });
        },
      });
  }

  // -------------------------------- Status Change -------------------------------- //

  getStatus(status: any) {
    switch (status) {
      case '101':
      case 1:
        return 'Review for Approval';
      case '115':
      case 2:
        return 'Order recived for Container';
      case '102':
      case 3:
        return 'Order placed';
      case '141':
      case 4:
        return 'Waste Disposed';
      default:
        return status ? 'Waste Disposed' : 'Yet to Dispose';
    }
  }

  // -------------------------------- Open Confirm Modal API -------------------------------- //

  openConfirmationModal(row: any, statusCode: any): void {
    console.log(row);
    this.selectedDumpsterAmnt = row.dumpsterAmount;
    this.selectedDumpyardAmnt = row.dumpyardAmount;
    this.selectedSmartSortAmnt = row.smartSortAmount;
    this.selectedRefundReqAmnt = row.sarRefundtoRequester;
    this.selectedRowOrderId = row.orderId;
    this.selectedRequestorId = row.requestorId;
    this.selectedStatusCode = statusCode;
    this.modalService.open(this.confirmationModal, {
      ariaLabelledBy: 'confirmation-modal-title',
    });
  }

  // -------------------------------- Payment API -------------------------------- //

  postOrderStatus(modal: any) {
    const reqBody: any = {
      userId: this.selectedRequestorId,
      orderId: this.selectedRowOrderId,
    };

    // Add the specific status code based on the payment type
    if (this.selectedStatusCode === 135) {
      reqBody.dumpsterStatusCode = this.selectedStatusCode;
      reqBody.dubsterAmt = this.selectedDumpsterAmnt;
    } else if (this.selectedStatusCode === 142) {
      reqBody.dumpyardStatusCode = this.selectedStatusCode;
      reqBody.dubYardAmt = this.selectedDumpyardAmnt;
    } else if (this.selectedStatusCode === 113) {
      reqBody.requestorStatusCode = this.selectedStatusCode;
      reqBody.requestorRefundAmt = this.selectedRefundReqAmnt;
    }

    console.log(reqBody);

    this.orderService
      .postApproveOrderStatus(apiEndPoints.paymentRelease, reqBody)
      .subscribe({
        next: (response: any) => {
          modal.close();
          this.toastr.success('SAR Credited Successfully', 'Success', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          });
          this.getReleasePayment();
        },
      });
  }

  // -------------------------------- Handle Payment for Dumpster, Dumpyard & Requestor -------------------------------- //

  handlePayment(row: any, type: any) {
    if (type === 'dumpster' && row.dumpesterOrderStatus !== '135') {
      console.log('dump');
      this.openConfirmationModal(row, 135);
    } else if (type === 'dumpyard' && row.dumpyarOrderStatus !== '142') {
      if (row.dumpesterOrderStatus !== '135') {
        this.toastr.warning('Start by paying for the dumpster', 'Warning', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true,
        });
        return;
      } else {
        this.openConfirmationModal(row, 142);
      }
    } else if (type === 'requestor' && row.orderStatus !== '113') {
      if (
        row.dumpesterOrderStatus !== '135' ||
        row.dumpyarOrderStatus !== '142'
      ) {
        this.toastr.warning(
          'Make the Dumpster & Dumpyard payment first',
          'Warning',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
        return;
      } else {
        this.openConfirmationModal(row, 113);
      }
    } else {
      if (
        (type === 'dumpster' && row.dumpesterOrderStatus === '135') ||
        (type === 'dumpyard' && row.dumpesterOrderStatus === '142') ||
        (type === 'requestor' && row.orderStatus === '113')
      ) {
        return;
      }
    }
  }

  filterData(type: string, searchTerm: string) {
    if (type == 'DUMPED_STATUS') {
      if (searchTerm == 'All') {
        this.releasePaymentList = this.originalTableData;
      } else {
        this.releasePaymentList = this.originalTableData.filter(
          (data: any) => data.dumpStatusText == searchTerm
        );
      }
    }

    if (type == 'CONTAINER_TYPE') {
      if (searchTerm == 'All') {
        this.releasePaymentList = this.originalTableData;
      } else {
        this.releasePaymentList = this.originalTableData.filter(
          (data: any) => data.containerType == searchTerm
        );
      }
    }

    if (type == 'ORDER_STATUS') {
      if (searchTerm == 'All') {
        this.releasePaymentList = this.originalTableData;
      } else {
        this.releasePaymentList = this.originalTableData.filter(
          (data: any) => data.orderStatus == searchTerm
        );
      }
    }
  }
}
